module.exports = __webpack_public_path__ + "static/media/no_avatar.3c6fb25b.png";